import { closeAllMenus, menuToggleClass } from './manager'

let previousPosition = 0
let menuRef = 0

// Menu aparece ou se esconde, de acordo com o scroll do usuário
export const scrollingManager = (menuRefPosition) => {
  const currentPosition = window.scrollY
  const scrollingUpPage = currentPosition < previousPosition
  const scrollingAboveHeader = currentPosition <= menuRefPosition
  const scrollingBelowHeader = currentPosition > menuRefPosition
  const isDeskResolution = window.innerWidth >= 991

  // Após realizar toda a lógica, atualiza o a posição anterior com valor atual
  previousPosition = currentPosition

  // Fecha E atualiza Estado do Menu ao dar Scroll
  if (scrollingBelowHeader && isDeskResolution) {
    ['mdn-Menu-main-isActive', 'mdn-Menu-top-isActive'].every((e) => {
      const bodyElement = document.querySelector('body')
      const isOpenMenu = bodyElement .classList.contains(e)

      isOpenMenu && closeAllMenus()
    })
  }

  // Menu "Aparece" ao scrollar para cima
  // Menu "Some" ao scrollar para baixo
  if (scrollingBelowHeader && scrollingUpPage) {
    menuToggleClass('body', 'remove', 'mdn-Menu-scroll--down')
    menuToggleClass('body', 'add', 'mdn-Menu-scroll--up')
  } else if (scrollingAboveHeader) {
    menuToggleClass('body', 'remove', 'mdn-Menu-scroll--up')
    menuToggleClass('body', 'remove', 'mdn-Menu-scroll')
  } else {
    const bodyElement = document.getElementsByTagName('body')[0]
    const directionUp = bodyElement.classList.contains('mdn-Menu-scroll--up')

    if (directionUp) {
      menuToggleClass('body', 'add', 'mdn-Menu-scroll--down')
      menuToggleClass('body', 'remove', 'mdn-Menu-scroll--up')
    } else if (currentPosition > 0) {
      menuToggleClass('body', 'add', 'mdn-Menu-scroll')
    }
  }
}

// Captura Scroll para todas as funções que dependem disso para realizar a lógica
export const scrollingMenu = () => {
  const getSelector = document.querySelector('.mdn-Menu-top')
  const topMenuH = getSelector ? getSelector.clientHeight : 0
  menuRef = topMenuH != undefined ? topMenuH + 70 : 0

  scrollingManager(menuRef)
}

export const eventMenuScrollTop = () => {
  const getMenuScrolling = document.querySelector('.mdn-Menu.mdn-isMenuScrolling')

  getMenuScrolling && scrollingMenu()
}
